import PlanificationJobPrefacturationsController from './planification.job.prefacturations.controller';

export default {
    template: require('./planification.job.prefacturations.html'),
    controller: PlanificationJobPrefacturationsController
};
